<template>
    <customer-layout>
        <div class="flex flex-col justify-between min-h-screen pb-16 bg-gray-50">
            <div>
                <section class="pt-6 text-white bg-gray-800">
                    <h2 class="p-4 text-xl font-bold text-center">{{ $t('Listen to these 4 audiobooks,') }}<br> <span class="text-pink-600">{{ $t('earn 12 OSM Coins') }}</span><br> {{ $t('and change your career and your life') }}</h2>
                </section>
                <div class="mx-auto mt-4 md:max-w-screen-xl">
                    <h1 class="px-4 my-2 text-xl font-bold">
                        Free Audio's
                    </h1>
                    <div class="flex flex-col flex-wrap w-full sm:flex-row">
                        <inertia-link
                            class="w-full px-4 sm:w-6/12 md:w-4/12 lg:w-3/12 border-box"
                            :href="route('audiobook.show', audioBookDetails.id)"
                            v-for="(audioBookDetails, index) in allAudioBooks"
                            :key="index"
                        >
                            <app-audio-book-card :bookDetails="audioBookDetails" class="w-full"/>
                        </inertia-link>
                    </div>
                </div>
                <div v-if="purchased.length > 0" class="px-4 mx-auto mt-4 md:max-w-screen-xl">
                    <h1 class="my-2 text-xl font-bold">
                        Purchased Audio's
                    </h1>
                    <div class="flex flex-col flex-wrap w-full sm:flex-row">
                        <div class="w-full px-4 sm:w-6/12 md:w-4/12 lg:w-3/12 border-box" v-for="(productDetails, index) in purchased" :key="index">
                            <PurchasedProductCard :bookDetails="productDetails" class="w-full"/>
                        </div>
                    </div>
                </div>
                <div class="py-4 text-center">
                    <span class="text-sm">{{ $t("There is something more for your career.") }} <a href="shop" class="underline">{{ $t("Let's add some items.") }}</a></span>
                </div>
            </div>
            <BottomBar :diamonds="diamonds"/>
        </div>
    </customer-layout>
</template>

<script>
    import AppAudioBookCard from "@/Components/AppAudioBookCard.vue";
    import data from "../../../data/AudioBooks.json";
    import BottomBar from "@/Layouts/BottomBar";
    import PurchasedProductCard from "../../Components/Product/PurchasedProductCard.vue"
    import CustomerLayout from '@/Layouts/CustomerLayout.vue';

    export default {
        props: [
            "diamonds",
            'allAudioBooks',
            'purchased'
        ],
        components: {
            BottomBar,
            AppAudioBookCard,
            PurchasedProductCard,
            CustomerLayout
        },
        data() {
            return {
                audioBooks: data,
            }
        },
    };
</script>

<style></style>
